const saveToPersistance = value => {
  localStorage.setItem('auth', JSON.stringify(value));
  return true;
};

const getFromPersistance = () => {
  const response = localStorage.getItem('auth');
  if (!response) {
    return false;
  }
  return true;
};

const removePersistance = () => {
  localStorage.removeItem('auth');
  return true;
};

export { saveToPersistance, getFromPersistance, removePersistance };
